import { ON_DEMANDS_PATH } from 'cpmCarparks/navigation';

module.exports = {
  path: ON_DEMANDS_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./CarparkOnDemands'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/routes/show/routes/onDemands/index.js